import React, { Component } from 'react';

// Styles
import './index.css';
import { Container, Card, Row, Col } from 'react-bootstrap';

// Main UIs
import GitCards from './GitCards';
import Footer from '../Footer/Footer';

// Importing Information of each member
import { Aboutinfo } from '../../shared/Aboutinfo';

// Importing Aos
import AOS from 'aos';
import 'aos/dist/aos.css';

// About Page Class
class AboutPage extends Component {

    constructor(props) {
        super(props);
        AOS.init({ duration: 700, delay: 0, once: true });
    }

    render() {
        return <>
            <Container className="main-margin-top">
                <center>
                    <div style={{ margin: "40px auto 0", textAlign: "center" }} data-aos="slide-right">
                        <img style={{ width: "300px", margin: "auto" }} src='/assets/ProfilePhotos/codemergers.png' alt="CodeMergers" />
                        <p id="main-h5" style={{ textAlign: "center" }}>We are <a href="https://github.com/Code-Mergers" target="_blank" rel="noopener noreferrer">Code Mergers </a> - group of student developers</p>
                        <h6 style={{ textAlign: "center" }}>Reacting with codes</h6>
                    </div>
                    <br />
                    <hr />
                    <GitCards />
                    <br />
                    <br />
                    <h2 id="main-h2">Members</h2>
                    {
                        Aboutinfo.map((about, index) => {
                            return <>
                                <Card key={index} data-aos="zoom-in" className="about-card"
                                    style={{ width: '95%', height: "100%", border: "none", boxShadow: "none" }}>
                                    <Row>
                                        <Col sm={{ span: "3" }} style={{ margin: "auto" }}>
                                            <Card.Img style={{ width: "90%", padding: "5%" }} src={about.image} alt={about.image.split('/')[3]} />
                                        </Col>
                                        <Col sm={{ span: "8" }} style={{ justifyContent: "center" }}>
                                            <Card.Body>
                                                <Card.Title style={{ textAlign: "center", padding: "0 2%", color: "#007bff", textDecoration: "none" }}>
                                                    {about.name}
                                                </Card.Title>
                                                <Card.Text style={{ textAlign: "left", padding: "0 2%" }}>
                                                    <p id="main-h5" style={{ fontSize: "15px" }}>
                                                        {about.description}
                                                        <br />
                                                        <strong>Languages: </strong>{about.language}
                                                    </p>
                                                </Card.Text>
                                                <Card.Link href={about.source} target="_blank" rel="noopener noreferrer">
                                                    <i className="fa fa-linkedin-square" aria-hidden="true" style={{ fontSize: "40px", color: '#007bff' }} />
                                                </Card.Link>
                                                <Card.Link href={about.source1} target="_blank" rel="noopener noreferrer">
                                                    <i className="fa fa-github" aria-hidden="true" style={{ fontSize: "40px", color: '#007bff' }} />
                                                </Card.Link>
                                                {
                                                    about.source2 !== "#" ?
                                                        <Card.Link href={about.source2} target="_blank" rel="noopener noreferrer">
                                                            <i className="fa fa-globe" aria-hidden="true" style={{ fontSize: "40px", color: '#007bff' }} />
                                                        </Card.Link> : ""
                                                }
                                                <Card.Link href={about.email} target="_blank" rel="noopener noreferrer">
                                                    <i className="fa fa-envelope" aria-hidden="true" style={{ fontSize: "40px", color: '#007bff' }} />
                                                </Card.Link>
                                            </Card.Body>
                                        </Col>
                                    </Row>
                                </Card>
                                <br />
                            </>
                        })
                    }
                </center>
            </Container>
            <br />
            <br />
            <Footer />
        </>
    }
}

export default AboutPage;